__turbopack_context__.v({
  "loader-logo": "EaKKFG_loader-logo",
  "loader-spinner": "EaKKFG_loader-spinner",
  "progressCircle": "EaKKFG_progressCircle",
  "progressContainer": "EaKKFG_progressContainer",
});
